import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, FormGroup, Grid, Hidden, IconButton, List, ListItem, SelectChangeEvent, Skeleton, Theme, Typography, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { RootStateType } from '../../../redux-store/reducers';
import BreadCrum from '../../../lib/BreadCrum';
import { getMandatesList, setAppliedFundsFilters, setCheckedHoldingSchemes, setSelectedAllHoldingsInfo, setSelectedHoldingsIds, setSelectedHoldingsInfo, setSelectedSchemesObj } from '../../../redux-store/actions/investorProfile';
import HoldingFundMore from '../common/HoldingFundMore';
import MoreFundsModal from '../common/MoreFundsModal';
import { HoldingsTableData } from '../mutualFund/holdings/types';
import ConfirmRecomment from '../common/ConfirmRecomment';
import RiskProfilePopup from '../common/RiskProfilePopup';
import AddtoCardPopup from '../common/AddtoCardPopup';
import SuccessModal from '../common/SuccessModal';
import FiveSchemeErrorMessage from '../mutualFund/common/FiveSchemeErrorMessage';
import ValidateDialogBox from '../mutualFund/common/ValidateDialogBox';
import { applicantStatusMasters, COMMON_EDIT, ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD, MAX_SCHEMES_SELECTED, MPOWER_ACCOUNT_TYPE_MASTER, USER_ROLES } from '../../../utils/constant';
import { FieldArray, Form, Formik, FormikProps, FormikValues } from 'formik';
import { BlackExitIcon, BluePlusIcon, CheckIcon, EmailIcon, FailureIcon, Phoneicon, UnCheckIcon } from '../../../assets/SvgIcons';
import { checkIfApplicationIsNonIndividual, formatCurrency, getModeOfHoldingDisplay, isApplicationNonIndividual, isModuleAllowed, isOnboardingTypeMinor, maskInfo, toINR } from '../../../utils/utilityFunctions';
import { EnuinStatusObj, GETINVESTMENTDETAILTYPE, GetInvestmentUserDetails, GetNotificationsResponseBody, getTransactionStatusCheckRes, TransactionStatusObj } from '../../../redux-store/types/api-types';
import { euinCheck, getInvestmentDetails, getInvestmentUserDetails, getRiskProfileCheck, getTransactionStatus, getTransactionStatusCheck, submitInvestmentDetails, submitRecomment } from '../../../redux-store/actions/funds';
import { MandateListItem, MandatesListResBody } from '../../../redux-store/types/investorProfile';
import Card from './Card';
import * as Yup from 'yup';
import { MpowerValidationType } from '../types';
import dayjs from 'dayjs';
import { addToCart, getCartItemsCount, setCartItemsCount } from '../../../redux-store/actions/cart';
import { AddToCartResponseBody, GetCartItemsCountResponseBody } from '../../../redux-store/types/cart';
import { handleDateValidation } from './Sip';
import TransactionsDocumentUpload from '../../../lib/TransactionsDocumentUpload';
import { BankDetails, GetBankBalanceResponseBody, GetOrderEntryBanksListResponseBody } from '../../../redux-store/types/orderManagement';
import { getBankBalance, getOrderEntryBanksList } from '../../../redux-store/actions/orderManagement';
import { CustomeBlueDropDown } from './FromInput';
import { CustomeButton } from '../../../lib/formik/NewFormInputs';
import { showError } from '../../../redux-store/actions/auth';
import { cancelPlaceOrderOnSkip, registerPlaceOrderOnSkip } from '../../../redux-store/nomineeRetryRegistry';
import TransactionStatusPopup from '../common/TransactionStatusPopup';
import EUINPopup from '../common/EUINPopup';
import TransactionStatusCheckPopup from '../common/TransactionStatusCheckPopup';
import { getNotifications } from '../../../redux-store/actions/notifications';
import { storeNotifications } from '../../../redux-store/actions/navbarInfo';
import { TransactionsDisclaimer, TransactionsDisclaimerText } from '../../ApplicationDetails/TermsAndConditions';


const initialData = {
    fund: [
        {
            sip: {
                sipamount: '',
                periods: '',
                installments: '',
                sipDate: '',
                endDate: '',
                mandate: '',
                sipFolio: '',
                firstOrder: false,
                sipUntilCancel: false,
            },
            lumpsum: {
                lumpAmount: '',
                lumpsumFolio: '',
            },
            activeTab: 'Lumpsum',
        },

    ]
}
export const bseStarStatusColorMap: Record<string, string> = {
    pending: 'warning.500',
    active: 'success.500',
    failed: 'error.500',
    disabled: 'error.500'
}




const Transaction = () => {
    const { palette, typography } = useTheme();
    const history = useHistory();
    const { pathname, state } = history.location;
    const dispatch = useDispatch();
    const {
        role = '',
        permissions = []
    } = useSelector((store: RootStateType) => store.auth);

    const {
        selectedSchemesObj = {},
        selectedHoldingsIds,
        selectAllHoldingsInfo
    } = useSelector((store: RootStateType) => store.investorProfile);
    const {
        selectedPortfolio,
        selectedPortfolioObj
    } = useSelector((store: RootStateType) => store.selectedPortfiolio);

    const { investorClientId = "", iwappRmId = "", clientInterfaceCode } = useSelector((store: RootStateType) => store.id)
    const { investorRmId = "" } = useSelector((store: RootStateType) => store.sessionData)
    const { locale, currencyCode, currencySymbol } = useSelector((store: RootStateType) => store.currencyInfo);

    const {
        selectedSchemes = [],
        clientCode,
        folio = [],
        schemeDetails = [],
        fund: stateFund = []
    } = (state as {
        selectedSchemes?: any[],
        clientCode: string,
        folio?: {
            folioId?: string,
            schemeId?: string,
            marketValue: number,
            investedValue: number,
            id: string
        }[],
        schemeDetails?: {
            scheme_id: string,
            isReinvestment: string
        }[],
        fund?: any[]
    }) ?? []

    const [schemeAllDetails, setSchemeAllDetails] = useState<Array<{ scheme_id: string, isReinvestment: string }>>(schemeDetails);

    const formRef = useRef<FormikProps<FormikValues>>(null);

    //state
    const [open, setOpen] = useState(false);
    const [holdingsData, setHoldingsData] = useState<HoldingsTableData[]>([])
    const [apiLoading, setApiLoading] = useState<'order' | 'recomment' | 'investor' | "">("");
    const [confirmRecomment, setConfirmRecomment] = useState(false);
    const [orderType, setOrderType] = useState<'order' | 'recomment' | 'investor'>('order');
    const [riskProfilePopup, setRiskProfilePopup] = useState<boolean>(false);
    const [riskPopupText, setRiskPopupText] = useState<string>('');
    const [cartPopup, setCartPopup] = useState<boolean>(false);
    const [isFiveSchemesDialogVisible, setFiveSchemesDialogVisible] = useState<boolean>(false)
    const [isValidationDialogVisible, setValidationDialogVisible] = useState<boolean>(false)
    const [validationErrorsArray, setValidationErrorsArray] = useState<{ schemeName: string; errorMessage: string }[]>([])
    const [riskPflChkLoading, setRiskPflChkLoading] = useState<boolean>(false);
    const [successModal, setSuccessModal] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [userDetails, setUserDetails] = useState<GetInvestmentUserDetails>({} as GetInvestmentUserDetails);
    const [isLoading, setIsLoading] = useState(true);
    const [details, setDetails] = useState<GETINVESTMENTDETAILTYPE>({} as GETINVESTMENTDETAILTYPE);
    const [activeMandateList, setActiveMandateList] = useState<MandateListItem[]>([]);
    const [formInitialData, setFormInitialData] = useState(initialData);
    const [isDocumentUploadDialogVisible, setDocumentUploadDialogVisible] = useState<boolean>(false);
    const [isDocumentUploadErrorDialogVisible, setDocumentUploadErrorDialogVisible] = useState<boolean>(false);
    const [recommendPlaceOrderResponse, setRecommendPlaceOrderResponse] = useState<any>({})
    const [bankAccountList, setBankAccountList] = useState<GetOrderEntryBanksListResponseBody>({} as GetOrderEntryBanksListResponseBody)
    const [isBankBalanceObjLoading, setBankBalanceObjLoading] = useState<boolean>(false)
    const [bankBalanceObj, setBankBalanceObj] = useState<GetBankBalanceResponseBody>({} as GetBankBalanceResponseBody)
    const [isSameSchemesDialogOpen, setSameSchemesDialogOpen] = useState<boolean>(false)

    const [transactionStatusPopup, setTransactionStatusPopup] = useState<boolean>(false);
    const [transactionStatusCheckPopup, setTransactionStatusCheckPopup] = useState<boolean>(false);
    const [TransactionStatusChkLoading, setTransactionStatusChkLoading] = useState<boolean>(false);
    const [transactionStatusPopupRes, setTransactionStatusPopupRes] = useState<TransactionStatusObj>({} as TransactionStatusObj);
    const [disclaimerChecked, setDisclaimerChecked] = useState<boolean>(false);
    const [isTxnDialog, setIsTxnDialog] = useState<boolean>(false);

    //AddMore fund Model
    const [radioValue, setRadioValue] = useState<any[]>([]);
    const [warning, setWarning] = useState<boolean>(false);

    const isInvestMore = pathname.split('/')[pathname.split('/').length - 1] === 'invest-more';

    const [EUINPopupVisible, setEUINPopupVisible] = useState<boolean>(false);
    const [EUINPopupRes, setEUINPopupRes] = useState<EnuinStatusObj>({} as EnuinStatusObj);
    const [EUINPopupLoading, setEUINPopupLoading] = useState<boolean>(false);
    const [transactionStatusCheckPopupRes, setTransactionStatusCheckPopupRes] = useState<getTransactionStatusCheckRes>({} as getTransactionStatusCheckRes);

    const [researchSchemesPopupVisible, setResearchSchemesPopupVisible] = useState<boolean>(false);
    const [researchSchemesMessage, setResearchSchemesMessage] = useState<string>('');
    const [researchSchemesList, setResearchSchemesList] = useState<string[]>([]);


    const investmentDetailsSchema = Yup.object().shape({
        fund: Yup.lazy((_value) => {
            const getValidation = (index: number, type: "SUB" | "RED" | "SIP" | "STP" | "SWP"): MpowerValidationType => {
                const validationData = _value[index]?.validations?.filter((item: MpowerValidationType) => item?.transactionType === type)[0] ?? {}
                return validationData
            }
            const getDateValidation = (index: number, type: "SUB" | "RED" | "SIP" | "STP" | "SWP", period: string): MpowerValidationType => {
                const validationData = _value[index]?.validations?.filter((item: MpowerValidationType) => item?.transactionType === type && item.frequency === period)[0] ?? {}
                return validationData
            }
            return Yup.array().of(
                Yup.object().shape({
                    sip: Yup.object().nullable().default(null).when('activeTab', {
                        is: 'SIP',
                        then: Yup.object().shape({
                            sipamount: Yup.number().required('SIP Amount is Required').positive('Amount must be greater than zero').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                // const validationData = getValidation(index, 'SIP')
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                return Number(value) >= (validationData?.minimumInstallmentAmount || 0) ? true : createError({ path, message: `Minimum amount is ${validationData?.minimumInstallmentAmount}` });
                            }),
                            periods: Yup.string().required('Frequency is Required'),
                            installments: Yup.number().nullable().when('sipUntilCancel', {
                                is: false,
                                then: Yup.number().nullable().
                                test('validations', '', function (value, context) {
                                    const { parent, createError, path } = context;
                                    const index = Number(path.match(/[\d,]+/g)?.[0])
                                    // const validationData = getValidation(index, 'SIP')
                                    const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                    if (parent.periods === 'DAILY') return true;
                                    if(!value){
                                        return createError({ path, message: 'Installments is Required' });
                                    }
                                    if(value<=0){
                                        return createError({path,message:'Installments must be greater than zero'});
                                    }
                                        return Number(value) >= (validationData?.minimumInstallments || 0) ? true : createError({ path, message: `Minimum installments is ${validationData?.minimumInstallments}` });
                                    }),
                                otherwise: Yup.number().nullable().notRequired()
                            }),
                            sipDate: Yup.date().nullable().typeError('Invalid Date').required('SIP Date is Required').test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)
                                // For past date
                                if ((dayjs(new Date()).isAfter(value, 'day'))) {
                                    return createError({ path, message: 'Past date is not allowed' });
                                }
                                // For T+1 date
                                if ((dayjs(new Date()).add(1, 'day').isAfter(value, 'day'))) {
                                    return createError({ path, message: 'Date should be T+1' });
                                }
                                const valid = handleDateValidation(validationData?.investmentDates, dayjs(value))
                                if (valid) {
                                    return createError({
                                        message: `Only ${validationData?.investmentDates.join(', ')} are allowed`,
                                        path
                                    })
                                }
                                return true



                                // if (validationData.schemeId) {
                                //     if ((dayjs(new Date()).isAfter(value, 'day'))) {
                                //         return createError({ path, message: 'Past date is not allowed' });
                                //     }

                                //     if (validationData?.investmentDates.length === 0) return true

                                //     // const validationDates = validationData?.investmentDates.includes(dayjs(value).format('DD'))
                                //     return validationData?.investmentDates?.includes(Number(dayjs(value).format('DD'))) ? true : createError({ path, message: `Date should be in ${validationData?.investmentDates?.join(', ')}` });

                                // } else {
                                //     return true
                                // }
                            }),
                            endDate: Yup.string().nullable().test('validations', '', function (value, context) {
                                const { parent, createError, path } = context;
                                const index = Number(path.match(/[\d,]+/g)?.[0])
                                const validationData = getDateValidation(index, 'SIP', parent?.periods)

                                if (parent.periods !== 'DAILY') return true;

                                if (!value) {
                                    return createError({ path, message: 'SIP End Date is Required' });
                                }

                                //date typeerror validation
                                if (!dayjs(value).isValid()) {
                                    return createError({ path, message: 'Invalid SIP End Date' });
                                }


                                // For past date
                                if ((dayjs(parent.sipDate).isAfter(value, 'day'))) {
                                    return createError({ path, message: 'SIP End Date should be greater than SIP Start Date' });
                                }
                                const valid = handleDateValidation(validationData?.investmentDates, dayjs(value), true)

                                if (valid) {
                                    return createError({
                                        message: `Only ${validationData?.investmentDates.join(', ')} are allowed`,
                                        path
                                    })
                                }
                                return true
                            }),
                            mandate: Yup.string().required('Mandate is Required'),
                            ...(isInvestMore ? {} : {
                                sipFolio: Yup.string().required('Required'),
                            }),
                        }),
                        otherwise: Yup.object().shape({
                            sipamount: Yup.number().notRequired(),
                            periods: Yup.string().notRequired(),
                            installments: Yup.number().notRequired(),
                            sipDate: Yup.date().notRequired(),
                            endDate: Yup.date().notRequired(),
                            mandate: Yup.string().notRequired(),
                            sipFolio: Yup.string().notRequired(),
                        })
                    }),
                    lumpsum: Yup.object().nullable().default(null).when('activeTab', {
                        is: 'Lumpsum',
                        then: Yup.object().shape({
                            lumpAmount: Yup.number().required('Lumpsum Amount is Required')
                                .positive('Amount must be greater than zero')
                                .test('validations', '', function (value, context) {
                                    const { parent, createError, path } = context;
                                    const index = Number(path.match(/[\d,]+/g)?.[0])
                                    const validationData = getValidation(index, 'SUB')

                                    const isNewFolioSelected = `${parent?.lumpsumFolio ?? ""}`?.toLowerCase() === "new folio"

                                    let minLumpsumAmount = validationData?.minimumInstallmentAmount ?? 0

                                    if (isInvestMore || (!isInvestMore && !isNewFolioSelected)) {
                                        minLumpsumAmount = validationData?.addtionalMinimumPurchaseAmpunt ?? 0;
                                    }

                                    return Number(value) >= (minLumpsumAmount || 0) ? true : createError({ path, message: `Minimum amount is ${String.fromCharCode(parseInt(currencySymbol, 16))} ${minLumpsumAmount}` });
                                }),
                            ...(isInvestMore ? {} : {
                                lumpsumFolio: Yup.string().required('Folio is Required'),
                            }),
                        }),
                        otherwise: Yup.object().shape({
                            lumpAmount: Yup.number().notRequired(),
                            lumpsumFolio: Yup.string().notRequired(),
                        })
                    }),
                })
            )
        }),
        ...((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            documents: Yup.array().of(
                Yup.object().shape({
                    documentId: Yup.string(),
                    documentType: Yup.string()
                })
            )
        } : {}),
        ...((
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        ) ? {
            bankAccountNumber: Yup.string().required("Bank Account is Required")
        } : {})
    });

    const mfTxnStatus = userDetails?.application?.bseClientActivationStatus?.toLowerCase() !== 'active';
    const fetchAll = async () => {
        try {
            if (!(selectedSchemes ?? []).length) {
                setIsLoading(false)

                setFormInitialData({
                    fund: [],
                    ...((
                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                        ![USER_ROLES.INVESTOR].includes(role) &&
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        documents: [{
                            documentId: "",
                            documentType: ""
                        }]
                    } : {}),
                    ...((
                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                    ) ? {
                        bankAccountNumber: ""
                    } : {}),
                } as any);

                return
            }

            setIsLoading(true);
            // setUserLoading(true);

            const payload = {
                schemeIds: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item),
                portfolioId: selectedPortfolio?.value,
                clientCode: clientCode,
                rmId: `${investorRmId}`,
                schemeDetails: selectedSchemes?.map((obj: any) => ({
                    scheme_id: obj?.scheme ?? "",
                    isReinvestment: obj?.isReinvestment ? obj?.isReinvestment : obj?.divReinvestAllowed ?? "",
                }))
            }
            // const [investmentUserDetailsResponse, mandateListResponse, investmentDetailsResponse] = await Promise.all([
            //     dispatch(getInvestmentUserDetails({ clientCode, portfolioId: selectedPortfolio?.value })) as unknown as GetInvestmentUserDetails,
            //     (dispatch(getMandatesList({ clientCode: clientCode, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<Array<MandatesListResBody>>),
            //     (dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown,
            // ]);

            const [mandateListResponse, investmentDetailsResponse] = await Promise.all([
                (dispatch(getMandatesList({ clientCode: clientCode, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>),
                (dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown,
            ]);

            // setUserDetails(investmentUserDetailsResponse as GetInvestmentUserDetails);
            setActiveMandateList(mandateListResponse?.mandates ?? mandateListResponse ?? []);
            setDetails(investmentDetailsResponse as GETINVESTMENTDETAILTYPE);

            // Check if response contains message and otherThanResearchSchemes
            const response = investmentDetailsResponse as GETINVESTMENTDETAILTYPE;
            if (response?.message && response?.otherThanResearchSchemes && response.otherThanResearchSchemes.length > 0) {
                setResearchSchemesMessage(response.message);
                setResearchSchemesList(response.otherThanResearchSchemes);
                setResearchSchemesPopupVisible(true);
            }

            if (
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
            ) {
                const getOrderEntryBanksListResponse = await (dispatch(getOrderEntryBanksList({
                    clientCode
                })) as unknown as Promise<GetOrderEntryBanksListResponseBody>);

                setBankAccountList(getOrderEntryBanksListResponse)
            }

            const formInitial = [...((investmentDetailsResponse as GETINVESTMENTDETAILTYPE)?.investmentDetails || [])]?.map((item, i) => ({
                ...initialData?.fund?.[0],
                sip: {
                    ...initialData?.fund?.[0]?.sip,
                    // sipamount: '',
                    periods: item.frequencies.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || '',
                    // installments: '',
                    // sipDate: '',
                    mandate: mandateListResponse?.mandates?.[0]?.mandateId || '',
                    sipFolio: item?.folios?.availableFolios[0] || '',
                    firstOrder: true,
                    sipUntilCancel: false,
                },
                lumpsum: {
                    ...initialData?.fund?.[0]?.lumpsum,
                    // lumpAmount: '',
                    lumpsumFolio: item?.folios?.availableFolios[0] || '',
                },
                // activeTab: 'Lumpsum',
                schemeId: item.schemeId,
                mandate: mandateListResponse,
                folio: folio[i],
                ...(isInvestMore ? {
                    uniqueId: selectedSchemes?.[i]?.uniqueId ?? ""
                } : {}),
                ...item,
            }))
            const modifiedInitialData = formInitial.map((item, i) => {
                const currentStateFund = stateFund[i];
                return {
                    ...item,
                    ...(currentStateFund && {
                        activeTab: currentStateFund.activeTab
                    }),
                    ...(currentStateFund && currentStateFund.activeTab === "Lumpsum" && {
                        lumpsum: {
                            ...item.lumpsum,
                            lumpAmount: currentStateFund.lumpsum.lumpAmount,
                            lumpsumFolio: currentStateFund.lumpsum.lumpsumFolio,
                        }
                    }),
                    ...(currentStateFund && currentStateFund.activeTab === "SIP" && {
                        sip: {
                            ...item.sip,
                            sipamount: currentStateFund.sip.sipamount,
                            periods: currentStateFund.sip.periods,
                            installments: currentStateFund.sip.installments,
                            sipDate: currentStateFund.sip.sipDate,
                            endDate: currentStateFund.sip.endDate,
                            sipFolio: currentStateFund.sip.sipFolio,
                            mandate: currentStateFund.sip.mandate,
                            firstOrder: currentStateFund.sip.firstOrder,
                            sipUntilCancel: currentStateFund.sip.sipUntilCancelFlag
                        }
                    })
                }
            })
            setFormInitialData({
                fund: COMMON_EDIT ? modifiedInitialData : formInitial,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: [{
                        documentId: "",
                        documentType: ""
                    }]
                } : {}),
                ...((
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    bankAccountNumber: ""
                } : {}),
            } as any);
        } catch (e) {
            console.log('error', e);
            throw e
        } finally {
            setIsLoading(false);
            // setUserLoading(false);
        }
    };

    const getUserData = async () => {
        try {
            setUserLoading(true);
            if (clientCode) {

                const investmentUserDetailsResponse = (await dispatch(getInvestmentUserDetails({
                    clientCode,
                    portfolioId: selectedPortfolio?.value
                }))) as unknown | GetInvestmentUserDetails;

                setUserDetails(investmentUserDetailsResponse as GetInvestmentUserDetails);
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setUserLoading(false)
        }
    }

    useEffect(() => {
        const getDataFromApi = async () => {
            await Promise.allSettled([fetchAll(), getUserData()])
        }
        if (clientCode) getDataFromApi()
    }, [clientCode]);

    useEffect(() => {
        return () => cancelPlaceOrderOnSkip();
    }, []);

    //router for bread crum
    const initialRouter = pathname?.split('/').filter((item) => item !== '')

    const rmRouterPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
        {
            name: 'Dashboard',
            path: '/dashboard',
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: initialRouter[1] + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Fund',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0 && !(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'),
            search: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "?tab=Holdings" : "?tab=Overview",
            handleClick: () => {
                if (!(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more')) dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            {
                name: 'Explore Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
                state: {
                    clientCode
                }
            },
        ]),
        {
            name: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}/${initialRouter[4]}`,
        },
    ] : [])

    const investorRouterPath = [
        {
            name: 'Dashboard' + `${selectedPortfolio.label ? `(${selectedPortfolio.label})` : ''}`,
            path: '/investor-dashboard',
            warning: selectedSchemes?.length > 0,
            handleClick: () => {
                dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        {
            name: 'Mutual Funds',
            path: `/${initialRouter[0]}/${initialRouter[1]}`,
            state: {
                clientCode
            },
            warning: selectedSchemes?.length > 0 && !(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more'),
            search: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "?tab=Holdings" : "?tab=Overview",
            handleClick: () => {
                if (!(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more')) dispatch(setSelectedAllHoldingsInfo([]))
            }
        },
        ...(pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? [
        ] : [
            {
                name: 'Explore Mutual Funds',
                path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`,
                state: {
                    clientCode
                }
            },

        ]),

        {
            name: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details',
            path: `/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}/${initialRouter[3]}`,
            state: {
                clientCode
            }
        },
    ]


    const handleConformOrder = async () => {
        const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)

        try {
            setApiLoading('order')

            const payload = [...formRef.current?.values?.fund].map((item, i) => {
                return {
                    "clientCode": clientInterfaceCode ? clientInterfaceCode : clientCode,
                    "fromScheme": item.schemeId,
                    "schemeName": item.fundName,
                    "mobile": userDetails?.mobile,
                    "email": userDetails?.email,
                    amcId: item.fundAmcId,
                    folio: item?.activeTab === "Lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                    ...((item?.sip === null || item?.sip?.sipamount === "" || item?.sip === undefined) ? {
                        amount: item?.lumpsum?.lumpAmount,
                        trType: "FRESH",
                        // trType: "LUMPSUM",
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folio: item?.folio?.folioId,
                            trType: "ADDITIONAL",
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                        } : {})
                    } : {
                        trType: "XSIP",
                        transactionStartDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                        endDate: item?.sip?.periods === "DAILY" ? dayjs(item?.sip?.endDate).format("DD/MM/YYYY") : "",
                        mandateId: item?.sip?.mandate,
                        noOfInstallments: item?.sip?.periods === "DAILY" ? 0 : item?.sip?.installments,
                        frequency: item?.sip?.periods,
                        amount: item?.sip?.sipamount,
                        // isFirstorderToday: "Y",
                        firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                        sipUntilCancelFlag: item?.sip?.sipUntilCancel ? "Y" : "N",
                        ...(pathname?.split('/')[pathname?.split('/')?.length - 1] !== 'invest-more' ? {} : {
                            folio: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                        } : {})
                    }),
                    portfolioId: selectedPortfolio?.value,
                    portfolioName: selectedPortfolio?.label,
                    rmId: `${investorRmId}`,
                    "cartId": null,
                    "isRecommended": true,
                    "isDiy": false,

                }
            })


            const res = await dispatch(submitInvestmentDetails({
                // ...(ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD ? {
                accountType: selectedPortfolioObj?.portfolioAccountType,
                // } : {}),
                orderDetails: payload,
                ...((
                    ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                    ![USER_ROLES.INVESTOR].includes(role) &&
                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                ) ? {
                    documents: formRef?.current?.values?.documents?.filter((obj: {
                        documentId: string;
                        documentType: string;
                    }) => obj.documentId !== "" && obj.documentType !== "")
                } : {})
            })) as unknown as {
                isSuccess: boolean,
                message: string,
                ordersValidation: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
                // const notificationsPayload = {
                //     rmId: [USER_ROLES.RM].includes(role) ? [`${iwappRmId}`] : [],
                //     category: [],
                //     clientCode: [USER_ROLES.INVESTOR].includes(role) ? [clientInterfaceCode] : [],
                //     limit: 3,
                //     page: 1,
                //     sort: 'notificationTimestamp',
                //     order: 'DESC'
                // }
                // const getNotificationsData = (await dispatch(getNotifications(notificationsPayload))) as unknown as GetNotificationsResponseBody;
                // dispatch(storeNotifications(getNotificationsData.data ?? []));
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res?.ordersValidation.length > 0) {
                    // if (res.message) {
                    //     setFiveSchemesDialogVisible(true)
                    // } else {
                    setValidationErrorsArray(
                        res?.ordersValidation
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data?.schemeName,
                                errorMessage: data?.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setConfirmRecomment(false);
            setRiskProfilePopup(false);
            setApiLoading("")
        }
    };

    const handleConfirmRecommend = async () => {
        try {
            setApiLoading("recomment")

            const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)

            const payload = [...formRef.current?.values?.fund].map((item, i) => {
                return {
                    // "trType": "FRESH",
                    clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                    amcId: item.fundAmcId,
                    schemeId: item.schemeId,
                    schemeName: item.fundName,
                    categoryName: item.fundType,
                    subCategoryName: item.fundCap,
                    riskType: item.riskType,
                    aumAmount: item.detailsList[0].value,
                    navValue: item.detailsList[1].value,
                    y3Returns: item.detailsList[2].value,
                    exitLoad: item.detailsList[3].value,
                    investedValue: 0,
                    marketValue: 0,
                    recommendedDate: dayjs().format("DD/MM/YYYY"),
                    imgUrl: item.fundImage,
                    folioNo: item?.activeTab === "Lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                    ...(item?.sip === null || item?.sip?.sipamount === '' || item?.sip === undefined ? {
                        buySellType: "LUMPSUM",
                        recommendedAmount: `${item.lumpsum?.lumpAmount}`,
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folioNo: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                        } : {})
                    } : {
                        buySellType: "XSIP",
                        mandateId: item?.sip?.mandate,
                        noOfInstallments: item?.sip?.periods === "DAILY" ? "" : `${item?.sip?.installments}`,
                        systematicDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                        endDate: item?.sip?.periods === "DAILY" ? dayjs(item?.sip?.endDate).format("DD/MM/YYYY") : "",
                        frequency: item?.sip?.periods,
                        recommendedAmount: `${item?.sip?.sipamount}`,
                        firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                        sipUntilCancelFlag: item?.sip?.sipUntilCancel ? "Y" : "N",
                        ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                            folioNo: item?.folio?.folioId,
                            investedValue: folio?.[i].investedValue,
                            marketValue: folio?.[i].marketValue,
                        }),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankName: selectedBankDetailsObj?.bankname ?? "",
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                            bankIfsc: selectedBankDetailsObj?.ifscCode ?? ""
                        } : {})
                    }),
                    portfolioId: selectedPortfolio?.value,
                    rmId: `${investorRmId}`
                }
            })

            const res = (await dispatch(submitRecomment(payload))) as unknown as {
                isSuccess: boolean,
                message: string,
                response: Array<any>
            };

            if (res.isSuccess) {
                setRecommendPlaceOrderResponse(res)

                setConfirmRecomment(false)
                dispatch(setSelectedHoldingsIds([]))
                dispatch(setCheckedHoldingSchemes([]))
                dispatch(setSelectedHoldingsInfo([]))
                dispatch(setSelectedAllHoldingsInfo([]))

                setSuccessModal(true);
            } else if (!res.isSuccess) {
                setConfirmRecomment(false)
                if (res?.response.length > 0) {
                    // if (res.message) {
                    //     setFiveSchemesDialogVisible(true)
                    // } else {
                    setValidationErrorsArray(
                        res.response
                            .filter(data => !data.isSuccess)
                            .map(data => ({
                                schemeName: data.schemeName,
                                errorMessage: data.message
                            }))
                    )
                    setValidationDialogVisible(true)
                }
            }
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setApiLoading("");
        }
    }

    const handleRiskProfilePopup = (btnText: string) => {
        setRiskProfilePopup(false);

        if (btnText === 'continue') {
            // if (orderType === 'order') {
            //     console.log(orderType, "Order flow")
            //     // For order flow, show confirmation popup directly
            //     handleConfirmRecommentOpen();
            // } else {

            // }
            handleConfirmRecommentOpen();
        }
    }

    const handleSuccess = () => {
        history.push('/cart', { clientCode })
    }

    const handleSuccessPopup = () => {
        dispatch(setAppliedFundsFilters([]));
        dispatch(setSelectedSchemesObj({}));

        if (role === USER_ROLES.INVESTOR) {
            history.push('/investor-dashboard')
        } else {
            history.push('/dashboard')
        }
        // if (role === USER_ROLES.INVESTOR) {
        //     history.push(`/${initialRouter[0]}/${initialRouter[1]}`, { clientCode })
        // } else {
        //     history.push(`/${initialRouter[0]}/${initialRouter[1]}/${initialRouter[2]}`, { clientCode })
        // }

    }

    const handleCloseFiveSchemesDialog = () => {
        setFiveSchemesDialogVisible(false)
    }

    const handleValidationDialogClose = () => {
        setValidationDialogVisible(false)
    }


    const hasDuplicateSchemes = (arr: any) => {
        const codeSet = new Set();

        for (const item of arr) {
            const key = `${item?.isinCode ?? ""}-${item?.folio?.folioId ?? ""}`;
            if (codeSet.has(key)) {
                return true;
            }
            codeSet.add(key);
        }

        return false;
    }

    const handleSameSchemeDialogClose = () => {
        setSameSchemesDialogOpen(false)
    }

    const handleTransactionStatusCheck = async () => {
        try {
            setTransactionStatusChkLoading(true);
            const transactionStatusCheckRes = (await dispatch(getTransactionStatus({
                clientCode: clientInterfaceCode ? clientInterfaceCode : '',
            }))) as unknown as TransactionStatusObj
            if (!transactionStatusCheckRes) {
                return
            }
            if (!transactionStatusCheckRes?.kycActive) {
                setTransactionStatusPopup(true)
                setTransactionStatusPopupRes(transactionStatusCheckRes)
            } else {
                handleConfirmRecommentOpen();
            }

        } catch (e) {
            console.log("Error: ", e)
        } finally {
            setTransactionStatusChkLoading(false)
        }
    }

    const handleTransactionStatusCheck1 = async () => {
        try {
            setTransactionStatusChkLoading(true);
            registerPlaceOrderOnSkip(() => handleConformOrder());
            const transactionStatusCheckRes = (await dispatch(getTransactionStatusCheck({
                rmId: `${iwappRmId ?? ''}`,
                clientCode: clientInterfaceCode ? clientInterfaceCode : investorClientId,
                // transactionType: 'sip'
            }))) as unknown as getTransactionStatusCheckRes;
            if (!transactionStatusCheckRes) return;
            cancelPlaceOrderOnSkip();
            const showPopup = transactionStatusCheckRes.isMessage;
            if (showPopup) {
                setTransactionStatusCheckPopup(true);
                setTransactionStatusCheckPopupRes(transactionStatusCheckRes);
            } else {
                // Transaction status check passed, now do risk profile check
                handleRiskProfileCheckForOrder();
            }
        } catch (e) {
            cancelPlaceOrderOnSkip();
            console.log("Error: ", e)
        } finally {
            setTransactionStatusChkLoading(false)
        }
    }

    const handleRiskProfileCheckForOrder = async () => {
        try {
            setRiskPflChkLoading(true);
            const riskProfileCheckRes = (await dispatch(getRiskProfileCheck({
                clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                // schemeCode: details.investmentDetails?.map((item: any) => {
                //     return item?.schemeId
                // })
                schemeCode: (formRef.current?.values?.fund ?? [])?.map((item: any) => {
                    return item?.schemeId
                })
            }))) as unknown as {
                isSuccess: boolean,
                displayText: string
            }
            if (orderType === 'order') {

                if (!riskProfileCheckRes?.isSuccess) {
                    setRiskProfilePopup(true)
                    setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                } else {
                    handleConfirmRecommentOpen();
                    // handleConformOrder()
                }
            } else {
                if (!riskProfileCheckRes?.isSuccess) {
                    setRiskProfilePopup(true)
                    setRiskPopupText(riskProfileCheckRes?.displayText || "Risk Profile Expired!")
                } else {
                    handleConfirmRecommentOpen(); //is for popup when success in trasaction
                }
            }
        } catch (e) {
            console.log('error', e)
        } finally {
            setRiskPflChkLoading(false);
        }

    }


    const handleConfirmRecommentOpen = async () => {
        setConfirmRecomment(true);
        // if (orderType !== 'order') {
        //     setConfirmRecomment(true);
        //     return;
        // }

    }

    const handleTransactionStatusPopup = async (btnText: string) => {
        setTransactionStatusPopup(false);
        if (btnText === 'continue') {
            handleConfirmRecommentOpen();
        }
    }

    const handleTransactionStatusCheckPopup = (btnText: string) => {
        setTransactionStatusCheckPopup(false);
        if (btnText === 'continue') {
            //  if (orderType === 'order') {
            //     console.log(orderType,"orderType");
            //     // For order flow, proceed to risk profile check
            //     handleRiskProfileCheckForOrder();
            // } else {
            //     handleConfirmRecommentOpen();
            // }
            handleRiskProfileCheckForOrder();
        }
    }

    const handleEuinCheckClose = () => {
        setEUINPopupVisible(false);
        EUINPopupRes?.isValid && setConfirmRecomment(true);
    }

    const handleSameSchemeDialogConfirm = async () => {
        handleSameSchemeDialogClose()

        if (!formRef.current) {
            return
        }

        if (orderType === 'investor') {
            const selectedBankDetailsObj = (bankAccountList?.bankDetails ?? [])?.find(obj => `${obj?.bankAccNo ?? ""}` === `${formRef.current?.values?.bankAccountNumber ?? ""}`)
            try {
                setApiLoading("investor");
                const payload = [...formRef.current?.values?.fund].map((item, i) => {
                    return {
                        categoryName: item.fundType,
                        isDividendReinvestment: item?.divReinvestAllowed ?? "",
                        mPowerScheme: item?.mPowerScheme ?? "",
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        navValue: item.detailsList[1].value,
                        y3Returns: item.detailsList[2].value,
                        exitLoad: item.detailsList[3].value,
                        aumAmount: item.detailsList[0].value,
                        riskType: item.riskType,
                        schemeId: item.schemeId,
                        schemeName: item.fundName,
                        subCategoryName: item.fundCap,
                        isRecommended: false,
                        navDate: item.detailsList[1].title.slice(5),
                        folioNo: item?.activeTab === "Lumpsum" ? item?.lumpsum?.lumpsumFolio : item?.sip?.sipFolio,
                        trType: (item?.sip === null || item?.sip?.sipamount === "" || item?.sip === undefined) ? (
                            isInvestMore ?
                                "ADDITIONAL" :
                                `${item?.lumpsum?.lumpsumFolio ?? ""}`.toLowerCase() === "new folio" ? "FRESH" : "ADDITIONAL"
                        ) : 'SIP',
                        investedValue: "0",
                        marketValue: "0",
                        amcId: item.fundAmcId,
                        ...((item?.sip === null || item?.sip?.sipamount === "" || item?.sip === undefined) ? {
                            amount: item?.lumpsum?.lumpAmount,
                            ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                                folioNo: item?.folio?.folioId,
                                // folioNo: folio?.filter(folioItem => folioItem.schemeId === details?.investmentDetails[i]?.schemeId)?.[0]?.id,
                                investedValue: `${folio?.[i]?.investedValue}`,
                                marketValue: `${folio?.[i]?.marketValue}`,
                            }),
                            ...((
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                bankName: selectedBankDetailsObj?.bankname ?? "",
                                bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                                bankIfsc: selectedBankDetailsObj?.ifscCode ?? "",
                            } : {})
                        } : {
                            amount: item?.sip?.sipamount,
                            mandateId: item?.sip?.mandate,
                            frequency: item?.sip?.periods,
                            noOfInstallment: item?.sip?.periods === "DAILY" ? 0 : item?.sip?.installments,
                            sipDate: dayjs(item?.sip?.sipDate).format("DD/MM/YYYY"),
                            endDate: item?.sip?.periods === "DAILY" ? dayjs(item?.sip?.endDate).format("DD/MM/YYYY") : "",
                            firstOrderFlag: item?.sip?.firstOrder ? "Y" : "N",
                            sipUntilCancelFlag: item?.sip?.sipUntilCancel ? "Y" : "N",
                            ...(pathname.split('/')[pathname.split('/').length - 1] !== 'invest-more' ? {} : {
                                folioNo: item?.folio?.folioId,
                                // folioNo: folio?.filter(folioItem => folioItem?.schemeId === details?.investmentDetails[i]?.schemeId)?.[0]?.id,
                                investedValue: `${folio?.[i]?.investedValue}`,
                                marketValue: `${folio?.[i]?.marketValue}`,
                            }),
                            ...((
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                bankName: selectedBankDetailsObj?.bankname ?? "",
                                bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? "",
                                bankIfsc: selectedBankDetailsObj?.ifscCode ?? "",
                            } : {})
                        }),
                        portfolioId: selectedPortfolio?.value,
                        // folioNo: item?.sip?.sipFolio || item?.lumpsum?.lumpsumFolio,
                        rmId: `${investorRmId}`,
                        transMode: 'A',
                    }
                })

                const res = ((await dispatch(addToCart(payload as any))) as unknown) as AddToCartResponseBody;
                if (res.isSuccess) {
                    setConfirmRecomment(false)
                    const { isSuccess, cartItemsCount } = await (dispatch(getCartItemsCount({
                        clientCode: clientInterfaceCode ? clientInterfaceCode : clientCode,
                        portfolioId: selectedPortfolio?.value
                    })) as unknown as Promise<GetCartItemsCountResponseBody>)

                    if (isSuccess) {
                        dispatch(setCartItemsCount(cartItemsCount));
                        dispatch(setSelectedHoldingsInfo([]))
                        dispatch(setSelectedAllHoldingsInfo([]))
                    }

                    setCartPopup(true)
                } else if (!res.isSuccess) {
                    setConfirmRecomment(false)
                    if (res.message) {
                        setFiveSchemesDialogVisible(true)
                    } else {
                        setValidationErrorsArray(
                            res.response
                                .filter(data => !data.isSuccess)
                                .map(data => ({
                                    schemeName: data.schemeName,
                                    errorMessage: data.message
                                }))
                        )
                        setValidationDialogVisible(true)
                    }
                }
            } catch (err) {
                console.log(err)
            } finally {
                setApiLoading("");
            }
        } else {
            // if (orderType === 'order') {


            handleTransactionStatusCheck1(); //this is transaction status check
            // } else {
            //     handleConfirmRecommentOpen();   //this is euin check 
            // }
        }
    }

    const newHandleSubmit = async (value: FormikValues) => {
        if ((
            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
            ![USER_ROLES.INVESTOR].includes(role) &&
            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        )) {
            if (value?.documents?.length === 1 && (value?.documents[0]?.documentId === '' || value?.documents[0]?.documentType === '')) {
                setDocumentUploadErrorDialogVisible(true)
                return
            }
        }

        if (isInvestMore) {

            // Checking if multiple orders with the same scheme/folio combination are there ot not

            const hasDuplicates = hasDuplicateSchemes(value?.fund ?? [])

            if (hasDuplicates) {
                setSameSchemesDialogOpen(true)
                return
            } else {
                handleSameSchemeDialogConfirm()
            }
        } else {
            handleSameSchemeDialogConfirm()
        }
    }

    const handleAddMore = () => {
        if (pathname.split('/').slice(-2)[0] === 'explore') {
            history.push(pathname.split('/').slice(0, -1).join('/'), { clientCode })
        } else {
            history.push(pathname.split('/').slice(0, -2).join('/'), { clientCode })
        }
    }

    const handleDelete = (id: number | string, checkId?: string, selectedUniqueId?: string) => {

        setDetails((pre: GETINVESTMENTDETAILTYPE) => {

            const result = pre?.investmentDetails?.filter((item) => item?.schemeId !== checkId);
            const result1 = pre?.investmentDetails?.filter((item) => item?.schemeId !== id);

            if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {

                // const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => (item?.scheme || item) !== id);
                const modifiedSelectedSchemes = selectedSchemes?.filter((item: any) => item.uniqueId !== selectedUniqueId);

                history.replace({
                    state: ({
                        selectedSchemes: modifiedSelectedSchemes,
                        clientCode,
                        schemeDetails: (modifiedSelectedSchemes ?? [])
                            .map(item => ({
                                scheme_id: item?.schemeId ?? "-",
                                isReinvestment: item?.isReinvest ?? "-"
                            })),
                        // folio: modifiedSelectedSchemes,
                        folio: (modifiedSelectedSchemes ?? [])
                            .map(item => ({
                                folioId: item.folioId,
                                schemeId: item.scheme,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                            })),
                    })
                })
                // const modifiedSelectedAllHoldingsInfo = selectAllHoldingsInfo.filter(({ id }) => id !== checkId)

                // dispatch(setSelectedAllHoldingsInfo([...modifiedSelectedAllHoldingsInfo]))

                // const modifiedCheckedIds = [...holdingsData].filter((obj) => checkedHoldingInvestments.includes(obj.id)).map(obj => obj.id)

                // dispatch(setSelectedHoldingsIds(modifiedSelectedSchemes))

            } else {
                history.replace({ state: { selectedSchemes: selectedSchemes?.filter((item: any) => (item?.scheme ? item?.scheme : item) !== id), clientCode } })

                const modifiedSelectedSchemesObj = Object.fromEntries(Object.entries(selectedSchemesObj).filter(([key, _]) => key !== `${id}`))

                dispatch(setSelectedSchemesObj(modifiedSelectedSchemesObj))

            }

            return { ...pre, investmentDetails: pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? result : result1 };
        })
    }

    const handleAddMoreProceed = () => {
        if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {
            history.replace({ state: ({ selectedSchemes: radioValue.map((obj: any) => (obj?.scheme || obj)), clientCode }) })

            dispatch(setSelectedHoldingsIds(radioValue.map((obj: any) => (obj?.scheme || obj))))

            addFunds(radioValue?.map((obj: any) => (obj?.scheme || obj)))
        } else {
            history.replace({ state: ({ selectedSchemes: radioValue, clientCode }) })

            const selectedSchemesObj = radioValue.reduce((acc: any, obj: any) => {
                acc[obj.scheme] = {
                    ...obj,
                    scheme: `${obj.scheme}`,
                    checked: obj.checked ? obj.checked : true,
                };
                return acc;
            }, {});
            dispatch(setSelectedSchemesObj(selectedSchemesObj))

            addFunds(selectedSchemesObj)
        }
        setOpen(false);

    }

    const addFunds = async (schemes: any, addedFolio?: any) => {
        try {
            if (isInvestMore) {

                // schemes currently in formik
                const currentSchemesArr = (formRef.current?.values?.fund ?? []).map((obj: any) => ({ uniqueId: obj?.uniqueId ?? "" }))

                // latest added schemes excluding the schemes in formik
                const latestAddedSchemes = schemes?.filter((obj: any) => !currentSchemesArr.find((currObj: any) => currObj.uniqueId === obj.uniqueId))

                if (!(latestAddedSchemes ?? []).length) {
                    return
                }

                setIsLoading(true);

                const payload = {
                    // passing only those schemeIds which have been added via Add more funds, NOT passing those schemes already in Formik
                    // schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                    schemeIds: (latestAddedSchemes ?? [])?.map((item: any) => item?.scheme ?? ""),
                    portfolioId: selectedPortfolio?.value,
                    clientCode: clientCode,
                    rmId: `${investorRmId}`,
                    // schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                    //     scheme_id: obj?.scheme ?? "",
                    //     isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    // }))
                    schemeDetails: (latestAddedSchemes ?? [])?.map((obj: any) => ({
                        scheme_id: obj?.scheme ?? "",
                        isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    }))
                }

                const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
                setDetails(res as GETINVESTMENTDETAILTYPE);

                // Check if response contains message and otherThanResearchSchemes
                const responseData = res as GETINVESTMENTDETAILTYPE;
                if (responseData?.message && responseData?.otherThanResearchSchemes && responseData.otherThanResearchSchemes.length > 0) {
                    setResearchSchemesMessage(responseData.message);
                    setResearchSchemesList(responseData.otherThanResearchSchemes);
                    setResearchSchemesPopupVisible(true);
                }

                // extracting ISIN codes from the response
                const responseIsinCodes = ((res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []).map((item: any) => item.isinCode) as Array<string>

                // Filtering out those schemes for which we did not get the api response based on the isin code
                const modifiedLatestAddedSchemes = latestAddedSchemes.filter((item: any) => responseIsinCodes.includes(item.isinCode));

                const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {

                    const addedFolio = {
                        folioId: modifiedLatestAddedSchemes[i].folioId,
                        schemeId: modifiedLatestAddedSchemes[i].scheme,
                        id: modifiedLatestAddedSchemes[i].id,
                        marketValue: modifiedLatestAddedSchemes[i].marketValue,
                        investedValue: modifiedLatestAddedSchemes[i].investedValue,
                    }

                    return {
                        ...item,
                        sip: {
                            sipamount: '',
                            periods: item?.frequencies?.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || '',
                            installments: '',
                            sipDate: '',
                            endDate: '',
                            mandate: activeMandateList[0]?.mandateId || '',
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: true,
                            sipUntilCancel: false,
                        },
                        lumpsum: {
                            lumpAmount: '',
                            lumpsumFolio: item?.folios?.availableFolios[0] || '',
                        },
                        activeTab: 'Lumpsum',
                        schemeId: item?.schemeId,
                        mandate: activeMandateList,
                        // folio: addedFolio?.[i],
                        folio: addedFolio,
                        uniqueId: modifiedLatestAddedSchemes?.[i]?.uniqueId ?? ""
                    }
                })

                const currentForm = [...formRef.current?.values.fund]
                // const newFrom = [...formInitial]

                // const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

                // const currentSchemeId = getId([...currentForm])
                // const newSchemeId = getId([...newFrom])

                // const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
                // const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

                const updatedFundsArray = [...currentForm, ...formInitial]

                history.replace({
                    state: ({
                        selectedSchemes: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                ...item,
                                folioId: item.folioNo,
                                scheme: item.schemeId,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                                isReinvestment: item?.isReinvest
                            })),
                        clientCode,
                        schemeDetails: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                scheme_id: item?.schemeId ?? "-",
                                isReinvestment: item?.isReinvest ?? "-"
                            })),
                        folio: [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]
                            .map((item: any) => ({
                                folioId: item.folioId,
                                schemeId: item.scheme,
                                id: item.id,
                                marketValue: item.marketValue,
                                investedValue: item.investedValue,
                            }))
                    })
                })

                dispatch(setSelectedHoldingsInfo(
                    [...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])].map(obj => ({
                        checkedId: obj?.id,
                        schemeId: obj?.scheme,
                        folioNo: obj?.folioNo ?? "",
                        uniqueId: obj?.uniqueId
                    }))))

                dispatch(setSelectedAllHoldingsInfo([...(selectedSchemes ?? []), ...(modifiedLatestAddedSchemes ?? [])]))

                formRef.current?.resetForm({
                    values: {
                        // fund: [...filteredCurrentForm, ...filteredNewData],
                        fund: updatedFundsArray,
                        ...((
                            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                            ![USER_ROLES.INVESTOR].includes(role) &&
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            documents: formRef.current?.values?.documents ?? []
                        } : {}),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                        } : {})
                    }
                })
            } else {
                if (!Object.keys(schemes ?? {}).length) {

                    formRef.current?.resetForm({
                        values: {
                            fund: [],
                            ...((
                                ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                ![USER_ROLES.INVESTOR].includes(role) &&
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                documents: formRef.current?.values?.documents ?? []
                            } : {}),
                            ...((
                                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                            ) ? {
                                bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                            } : {})
                        }
                    })

                    return
                }

                setIsLoading(true);
                const payload = {
                    schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
                    portfolioId: selectedPortfolio?.value,
                    clientCode: clientCode,
                    rmId: `${investorRmId}`,
                    schemeDetails: Object.values(schemes)?.map((obj: any) => ({
                        scheme_id: obj?.scheme ?? "",
                        isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
                    }))
                }

                const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
                setDetails(res as GETINVESTMENTDETAILTYPE);

                // Check if response contains message and otherThanResearchSchemes
                const responseData = res as GETINVESTMENTDETAILTYPE;
                if (responseData?.message && responseData?.otherThanResearchSchemes && responseData.otherThanResearchSchemes.length > 0) {
                    setResearchSchemesMessage(responseData.message);
                    setResearchSchemesList(responseData.otherThanResearchSchemes);
                    setResearchSchemesPopupVisible(true);
                }

                const formInitial = [...(res as GETINVESTMENTDETAILTYPE)?.investmentDetails ?? []].map((item, i) => {
                    return {
                        ...item,
                        sip: {
                            sipamount: '',
                            periods: item?.frequencies?.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || '',
                            installments: '',
                            sipDate: '',
                            endDate: '',
                            mandate: activeMandateList[0]?.mandateId || '',
                            sipFolio: item?.folios?.availableFolios[0] || '',
                            firstOrder: true,
                            sipUntilCancel: false,
                        },
                        lumpsum: {
                            lumpAmount: '',
                            lumpsumFolio: item?.folios?.availableFolios[0] || '',
                        },
                        activeTab: 'Lumpsum',
                        schemeId: item?.schemeId,
                        mandate: activeMandateList,
                        folio: addedFolio?.[i],
                    }
                })

                const currentForm = [...formRef.current?.values.fund]
                const newFrom = [...formInitial]

                const getSchemeId = (item: any) => item?.map((obj: any) => obj.schemeId)

                const currentSchemeId = getSchemeId([...currentForm])
                const newSchemeId = getSchemeId([...newFrom])

                const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.schemeId))
                const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.schemeId))

                formRef.current?.resetForm({
                    values: {
                        fund: [...filteredCurrentForm, ...filteredNewData],
                        ...((
                            ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                            ![USER_ROLES.INVESTOR].includes(role) &&
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            documents: formRef.current?.values?.documents ?? []
                        } : {}),
                        ...((
                            MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                            MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                        ) ? {
                            bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
                        } : {})
                    }
                })
            }
        } catch (err) {
            console.log('error', err)
        } finally {
            setIsLoading(false)
        }

        // try {
        //     setIsLoading(true);
        //     const payload = {
        //         schemeIds: Object.values(schemes)?.map((item: any) => item?.scheme ? item?.scheme : item),
        //         portfolioId: selectedPortfolio?.value,
        //         clientCode: clientCode,
        //         rmId: `${investorRmId}`,
        //         schemeDetails: Object.values(schemes)?.map((obj: any) => ({
        //             scheme_id: obj?.scheme ?? "",
        //             isReinvestment: obj?.isReinvestment ? obj?.isReinvestment ?? "" : obj?.divReinvestAllowed ?? "",
        //         }))
        //     }

        //     const res = (await dispatch(getInvestmentDetails(payload))) as GETINVESTMENTDETAILTYPE | unknown
        //     setDetails(res as GETINVESTMENTDETAILTYPE);
        //     const formInitial = [...(res as GETINVESTMENTDETAILTYPE).investmentDetails].map((item, i) => {
        //         return {
        //             ...item,
        //             sip: {
        //                 sipamount: '',
        //                 periods: item?.frequencies?.filter((freq) => freq.tranasactionType === 'SIP')[0]?.frequency || '',
        //                 installments: '',
        //                 sipDate: '',
        //                 mandate: activeMandateList[0]?.mandateId || '',
        //                 sipFolio: item?.folios?.availableFolios[0] || '',
        //             },
        //             lumpsum: {
        //                 lumpAmount: '',
        //                 lumpsumFolio: item?.folios?.availableFolios[0] || '',
        //             },
        //             activeTab: 'Lumpsum',
        //             schemeId: item?.schemeId,
        //             mandate: activeMandateList,
        //             folio: addedFolio?.[i],
        //         }
        //     })
        //     if (isInvestMore) {
        //         const currentForm = [...formRef.current?.values.fund]
        //         const newFrom = [...formInitial]

        //         const getId = (item: any) => item?.map((obj: any) => obj.folio.id)

        //         const currentSchemeId = getId([...currentForm])
        //         const newSchemeId = getId([...newFrom])

        //         const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.folio.id))
        //         const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.folio.id))

        //         formRef.current?.resetForm({
        //             values: {
        //                 fund: [...filteredCurrentForm, ...filteredNewData],
        //                 ...((
        //                     ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
        //                     [USER_ROLES.RM].includes(role) &&
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     documents: formRef.current?.values?.documents ?? []
        //                 } : {}),
        //                 ...((
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
        //                 } : {})
        //             }
        //         })

        //     } else {
        //         const currentForm = [...formRef.current?.values.fund]
        //         const newFrom = [...formInitial]

        //         const getSchemeId = (item: any) => item?.map((obj: any) => obj.schemeId)

        //         const currentSchemeId = getSchemeId([...currentForm])
        //         const newSchemeId = getSchemeId([...newFrom])

        //         const filteredNewData = newFrom.filter((item: any) => !currentSchemeId.includes(item.schemeId))
        //         const filteredCurrentForm = currentForm.filter((item: any) => newSchemeId.includes(item.schemeId))

        //         formRef.current?.resetForm({
        //             values: {
        //                 fund: [...filteredCurrentForm, ...filteredNewData],
        //                 ...((
        //                     ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
        //                   [USER_ROLES.RM].includes(role) &&
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     documents: formRef.current?.values?.documents ?? []
        //                 } : {}),
        //                 ...((
        //                     MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
        //                     MPOWER_ACCOUNT_TYPE_MASTER["POA"]
        //                 ) ? {
        //                     bankAccountNumber: formRef.current?.values?.bankAccountNumber ?? ""
        //                 } : {})
        //             }
        //         })

        //     }

        //     // setIsLoading(false);
        // } catch (err) {
        //     console.log('error', err)
        // } finally {
        //     setIsLoading(false)
        // }
    };

    const handleAddMoreChangeRadion = (data: any) => {
        setRadioValue(((pre: any) => {

            const remining = pre.filter((item: any) => (item?.scheme || item) === data.scheme)

            if (pre.length >= MAX_SCHEMES_SELECTED && !remining.length) {
                setWarning(true)
                return pre
            }
            if (remining.length === 0) {
                return [...pre, data]
            } else if (remining.length > 0) {
                return pre.filter((item: any) => (item?.scheme || item) !== data.scheme)
            }
        }));
    };

    const handleProceed = () => {
        const data = selectAllHoldingsInfo.map(item => ({
            ...item,
            folioId: item.folioNo,
            scheme: item.schemeId,
            id: item.id,
            marketValue: item.marketValue,
            investedValue: item.investedValue,
            isReinvestment: item?.isReinvest
        }))

        const checkedIds = data.map((obj) => obj.scheme)

        const folioData = data.map((obj) => ({
            folioId: obj.folioId,
            schemeId: obj.scheme,
            id: obj.id,
            marketValue: obj.marketValue,
            investedValue: obj.investedValue
        }))

        dispatch(setSelectedHoldingsIds([...[]]))
        dispatch(setCheckedHoldingSchemes([...checkedIds]))
        // if (pathname.split('/')[pathname.split('/').length - 1] === 'invest-more') {
        // history.replace({
        //     state: ({
        //         clientCode,
        //         selectedSchemes: [...data],
        //         folio: folioData
        //     })
        // })

        // } 
        // else {

        //     history.replace({ state: ({ selectedSchemes: [...data], clientCode }) })
        // }
        setOpen(false)

        addFunds([...data], folioData)
    }

    const handleDocumentUploadDialogOpen = () => {
        setDocumentUploadDialogVisible(true)
    }

    const handleDocumentUploadDialogClose = () => {
        setDocumentUploadDialogVisible(false)
    }

    const handleDocumentUploadErrorDialogClose = () => {
        setDocumentUploadErrorDialogVisible(false)
    }

    const handleSelectBankAccount = async (event: SelectChangeEvent<any>) => {
        try {
            if (!formRef.current) return

            setBankBalanceObjLoading(true)

            const { setFieldValue } = formRef.current ?? {}

            setFieldValue('bankAccountNumber', event.target.value);

            setBankBalanceObj({} as GetBankBalanceResponseBody)

            const response = await (dispatch(getBankBalance({
                investorBankAccount: event.target.value,
                clientCode: `${clientCode ?? ""}`,
                investorIfscCode: (bankAccountList?.bankDetails ?? [])?.find((item: any) => item?.bankAccNo === event.target.value)?.ifscCode ?? ""
            })) as unknown as Promise<GetBankBalanceResponseBody>);

            if (!response?.isSuccess) {
                dispatch(showError(response?.message ?? "No Data Available"))
            }

            setBankBalanceObj(response)
        } catch (error) {
            console.log("Error: ", error)
        } finally {
            setBankBalanceObjLoading(false)
        }
    }

    let successMessage = "";
    let subSuccessMessage = "";

    if (orderType === 'recomment') {
        successMessage = "Your Suggestion is sent successfully to the Investor."
    } else {
        if (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD && selectedPortfolioObj?.portfolioAccountType) {
            if (![USER_ROLES.INVESTOR].includes(role) &&
                MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                MPOWER_ACCOUNT_TYPE_MASTER["POA"]) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} sent to the checker for approval.`
            }
            if (![USER_ROLES.INVESTOR].includes(role) &&
                (MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                    MPOWER_ACCOUNT_TYPE_MASTER["EXY"] || isApplicationNonIndividual(userDetails?.applicationType ?? ""))
            ) {
                successMessage = `Your order${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} with order ID${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "s" : ""} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.map((obj: any) => obj?.id)?.join(', ')} ${(recommendPlaceOrderResponse?.status_responses ?? [])?.length > 1 ? "are" : "is"} successfully sent to the investor for approval. Once authorized and approved the order will be placed.`
                subSuccessMessage = `${recommendPlaceOrderResponse?.message ?? ""}`;
            }
        } else {
            successMessage = "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."
        }

    }

    const isMinor = isOnboardingTypeMinor(userDetails?.application?.onboardingType || '');
    const investorName = isMinor ? `${userDetails?.application?.applicants?.[0]?.minorFirstName} ${userDetails?.application?.applicants?.[0]?.minorLastName}` : userDetails?.name;

    return (
        <>
            <BreadCrum array={![USER_ROLES.INVESTOR].includes(role) ? rmRouterPath : investorRouterPath} />
            <Typography variant="h1" color={palette.text.primary} fontSize={{ sm: '16px', xs: '16px', md: '24px', lg: '24px' }} mt={2}>
                {pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Invest More" : 'Investment Details'}
            </Typography>
            <Formik
                innerRef={formRef}
                enableReinitialize
                // validateOnChange={false}
                initialValues={formInitialData}
                validationSchema={investmentDetailsSchema}
                onSubmit={newHandleSubmit}>
                {(formik) => (
                    <>
                        <Box component="form" onSubmit={formik.handleSubmit}>
                            <Grid container marginTop={2} spacing={2}>
                                <Grid item lg={8} md={12} sm={12} xs={12} sx={{ display: 'flex', rowGap: '25px', flexDirection: 'column' }}>
                                    <>
                                        <FieldArray
                                            name='fund'
                                            render={(arrayhelper) => {
                                                // return ((details?.investmentDetails || [...selectedSchemes.map((item: any) => '')])?.map((data, index) => (
                                                //     <Card key={index} {...{ isLoading, id: index, data, arrayhelper, handleDelete, clientCode, activeMandateList, folio: folio as any, selectedSchemes: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item) }} />
                                                // ))
                                                // )
                                                return (formik.values.fund)?.map((_data: FormikValues, index: number) => (
                                                    <Card key={index} {...{ isLoading, id: index, arrayhelper, handleDelete, clientCode, activeMandateList, folio: folio as any, selectedSchemes: selectedSchemes?.map((item: any) => item?.scheme ? item?.scheme : item), isSubmitting: !!apiLoading, bankAccountList, isBankBalanceObjLoading }} />
                                                ))
                                            }
                                            }
                                        />                                      
                                        {selectedSchemes.length < MAX_SCHEMES_SELECTED && (
                                            <Box
                                                component={'div'}
                                                sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                                                {
                                                    isLoading ?
                                                        <Skeleton variant="rectangular" width={200} height={30} /> :
                                                        <Hidden only={'xs'}>
                                                            <Button
                                                                variant="text"
                                                                onClick={() => setOpen(true)}
                                                                sx={{
                                                                    gap: '10px',
                                                                    '&:hover': {
                                                                        background: 'transparent',
                                                                    },
                                                                    '&:disabled': {
                                                                        opacity: 0.5
                                                                    }
                                                                }}
                                                                disabled={!!apiLoading || TransactionStatusChkLoading || isBankBalanceObjLoading}
                                                            >
                                                                <BluePlusIcon />
                                                                <Typography
                                                                    variant="body_500"
                                                                    color={palette.text.secondary}
                                                                    sx={{
                                                                        textDecoration: 'dashed',
                                                                        textDecorationColor: palette.primary[500],
                                                                        textDecorationThickness: '2px',
                                                                    }}>
                                                                    {pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Add More Holding" : "Add More Funds"}

                                                                </Typography>
                                                            </Button>
                                                        </Hidden>}
                                                <Hidden smUp={true}>
                                                    {isLoading ?
                                                        <Skeleton variant="rectangular" width={200} height={20} /> :
                                                        <Box
                                                            component={'button'}
                                                            onClick={() => handleAddMore()}
                                                            sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px', justifyContent: 'center', borderRadius: '10px', border: `1px solid ${palette.primary[500]}`, maxWidth: '271px', width: '100%', height: '49px', cursor: 'pointer', background: 'transparent' }}
                                                            disabled={isBankBalanceObjLoading}
                                                        >
                                                            <BluePlusIcon />
                                                            <Typography variant="body_500" fontFamily={typography.fontFamily} color={palette.primary[500]} sx={{ textDecoration: 'dashed', textDecorationColor: palette.primary[500], textDecorationThickness: '1px', textDecorationLine: 'underline' }}>
                                                                Add More Funds
                                                            </Typography>
                                                        </Box>}
                                                </Hidden>
                                            </Box>
                                        )}
                                    </>
                                </Grid>
                                <Grid item lg={4} md={12} sx={{ width: '100%' }}>
                                    {(
                                        ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                        ![USER_ROLES.INVESTOR].includes(role) &&
                                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                    ) && (
                                            <Box
                                                sx={{
                                                    background: palette.background.paper,
                                                    padding: '20px',
                                                    borderRadius: '20px',
                                                    marginBottom: "20px",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    border: `3px solid ${palette.stroke.main}`
                                                }}
                                                boxShadow={1}
                                            >
                                                <Typography
                                                    variant="body_500"
                                                    sx={{
                                                        lineHeight: "20px",
                                                        letterSpacing: "0.02px",
                                                        color: `${palette.text.secondary}B2`,
                                                    }}
                                                >
                                                    You can add minimum 1 attachment and maximum 5 attachments
                                                </Typography>
                                                <Typography
                                                    variant='body_400'
                                                    sx={{
                                                        color: palette.text.primary,
                                                        alignSelf: "flex-start",
                                                        marginTop: "10px"
                                                    }}
                                                >
                                                    Documents Uploaded: {
                                                        formik?.values?.documents?.filter((obj: {
                                                            documentId: string;
                                                            documentType: string;
                                                        }) => obj.documentId !== "" && obj.documentType !== "")?.length ?? "0"
                                                    }
                                                </Typography>
                                                <Button
                                                    sx={{
                                                        ...typography.body_500,
                                                        color: palette.primary[500],
                                                        padding: "5px",
                                                        fontWeight: 600,
                                                        marginTop: "15px"
                                                    }}
                                                    onClick={handleDocumentUploadDialogOpen}
                                                    disabled={isLoading || !!apiLoading || isBankBalanceObjLoading}
                                                >
                                                    Upload Documents
                                                </Button>
                                            </Box>
                                        )}
                                    {(
                                        MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                        MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                    ) && (
                                            <Box
                                                sx={{
                                                    background: palette.background.paper,
                                                    padding: '20px',
                                                    borderRadius: '20px',
                                                    marginBottom: "20px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    rowGap: "15px"
                                                }}
                                                boxShadow={1}
                                            >
                                                <Box sx={{ width: "100%" }}>
                                                    <CustomeBlueDropDown
                                                        isLoading={isLoading || isBankBalanceObjLoading}
                                                        label='Select Bank Account'
                                                        disabled={!!apiLoading}
                                                        name="bankAccountNumber"
                                                        list={(bankAccountList?.bankDetails ?? [])?.map(
                                                            (obj: BankDetails) => ({ label: `${obj?.bankAccNo} ${obj?.bankname}`, value: obj?.bankAccNo })
                                                        )}
                                                        onChange={handleSelectBankAccount}
                                                    />
                                                </Box>
                                                {(!(isLoading || isBankBalanceObjLoading) && (Object.keys(bankBalanceObj ?? {}).length > 0)) && (
                                                    <Typography
                                                        variant='body_500'
                                                        sx={{ color: palette.text.secondary }}
                                                    >
                                                        Available Balance: {toINR({ value: (bankBalanceObj.bankBalance ?? 0), locale, currencyCode })}
                                                    </Typography>
                                                )}
                                            </Box>
                                        )}
                                    <Box
                                        sx={{
                                            background: palette.background.paper,
                                            padding: '25px 30px 30px',
                                            borderRadius: '20px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            gap: '35px',
                                        }}
                                        boxShadow={1}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            {userLoading ? (
                                                <CircularProgress />
                                            ) : (
                                                <img
                                                    src={`https://ui-avatars.com/api/?name=${`${investorName}`}&background=${palette.primary[50]?.slice(1)}&color=${palette.primary[500]?.slice(
                                                        1
                                                    )}`}
                                                    style={{ borderRadius: '50%' }}
                                                    alt="Bank name"
                                                />
                                            )}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    rowGap: "5px",
                                                    flex: 1
                                                }}
                                            >
                                                {userLoading && (
                                                    <>
                                                        <Skeleton variant='text' animation="wave" />
                                                        <Skeleton variant='text' animation="wave" />
                                                    </>
                                                )}
                                                {!userLoading && (
                                                    <>
                                                        <Typography
                                                            variant='h2'
                                                            sx={(theme: Theme) => ({
                                                                lineHeight: "25px",
                                                                letterSpacing: "0.01px",
                                                                color: theme.palette.text.primary
                                                            })}
                                                        >
                                                            {maskInfo(investorName || '')}
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "5px",
                                                                flexWrap: "wrap",
                                                            }}
                                                        >
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {/* {userDetails?.applicationType ?? ""} */}
                                                                {
                                                                    isMinor
                                                                        ? "Minor"
                                                                        : userDetails?.status ?
                                                                            applicantStatusMasters[userDetails.status] ?
                                                                                applicantStatusMasters[userDetails.status] : userDetails.status
                                                                            : "N/A"
                                                                }
                                                            </Typography>
                                                            {/* <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant='body_500'
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {selectedPortfolio?.label ?? ""}
                                                            </Typography> */}
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary
                                                                })}
                                                            >
                                                                {userDetails?.accountType ?? ""}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {getModeOfHoldingDisplay(userDetails?.modeOfHolding || "") ?? "-"}
                                                            </Typography>
                                                            {/* <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary
                                                                })}
                                                            >
                                                                {
                                                                    isMinor
                                                                        ? "Minor"
                                                                        : userDetails?.status ?
                                                                            applicantStatusMasters[userDetails.status] ?
                                                                                applicantStatusMasters[userDetails.status] : userDetails.status
                                                                            : "N/A"
                                                                }
                                                            </Typography> */}
                                                            <Box
                                                                sx={{
                                                                    width: "3px",
                                                                    height: "3px",
                                                                    backgroundColor: "text.secondary",
                                                                    alignSelf: "center",
                                                                    borderRadius: "50%"
                                                                }}
                                                            />
                                                            <Typography
                                                                variant="body_500"
                                                                sx={(theme: Theme) => ({
                                                                    lineHeight: "20px",
                                                                    letterSpacing: "0.02px",
                                                                    color: theme.palette.text.secondary,
                                                                    textTransform: "capitalize"
                                                                })}
                                                            >
                                                                {userDetails?.application?.clientInterfaceCode ?? ""}
                                                            </Typography>
                                                        </Box>
                                                    </>
                                                )}
                                            </Box>
                                        </Box>
                                        {![USER_ROLES.INVESTOR].includes(role) &&
                                            <Box width={'100%'}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                    <EmailIcon />
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                                    ) : (
                                                        <Typography variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }} color={palette.text.primary}>
                                                            {maskInfo(userDetails?.email || '')}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                    <Phoneicon />
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                                    ) : (
                                                        <Typography variant="body_500" fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }} color={palette.text.primary}>
                                                            {maskInfo(userDetails?.mobile || '')}
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%' }}>
                                                    <Typography>MF Transaction Status:</Typography>
                                                    {userLoading ? (
                                                        <Skeleton variant="text" animation="wave" width={'100%'} />
                                                    ) :
                                                        (
                                                            <Typography
                                                                variant="body_500"
                                                                color={bseStarStatusColorMap[`${userDetails?.application?.bseClientActivationStatus ?? ""}`.toLowerCase()] ?? 'text.primary'}
                                                                sx={{
                                                                    letterSpacing: '0.02px',
                                                                    textTransform: "capitalize"
                                                                }}
                                                            >
                                                                {userDetails?.application?.bseClientActivationStatus ?? 'N/A'}
                                                            </Typography>
                                                        )}
                                                </Box>


                                            </Box>
                                        }
                                        {/* Disclaimer */}
                                        {USER_ROLES.INVESTOR !== role && (userLoading ? (
                                            <Skeleton variant="text" animation="wave" width={'100%'} />
                                        ) : (
                                            <Box sx={{ width: '100%', mt: 3 }}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        sx={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}
                                                        control={
                                                            <Checkbox
                                                                size="medium"
                                                                disableRipple
                                                                checkedIcon={<CheckIcon />}
                                                                icon={<UnCheckIcon />}
                                                                sx={{
                                                                    padding: 0,
                                                                    '&:hover': {
                                                                        backgroundColor: 'transparent',
                                                                    },
                                                                }}

                                                                onChange={() => setIsTxnDialog(true)}
                                                                checked={disclaimerChecked}
                                                            />}
                                                        label={<TransactionsDisclaimer disclaimerChecked={disclaimerChecked} setDisclaimerChecked={setDisclaimerChecked} />}
                                                    />

                                                </FormGroup>
                                            </Box>
                                        ))}

                                        <Divider />
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: { lg: 'column', md: 'column', sm: 'row-reverse', xs: 'row-reverse' },
                                                gap: '10px',
                                                justifyContent: { lg: 'center', md: 'center', sm: 'space-between', xs: 'space-between' },
                                                alignItems: 'center',
                                            }}>
                                            {isLoading ? (
                                                <Skeleton variant="text" animation="wave" width={100} />
                                            ) : (
                                                <Typography variant="h1" fontSize={{ sm: '20px', xs: '20px', md: '32px', lg: '32px' }} color={palette.text.primary}>
                                                    {toINR({
                                                        value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') : parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                        locale,
                                                        currencyCode
                                                    }).length > 16 ? formatCurrency({
                                                        value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') :
                                                            parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                        locale,
                                                        currencyCode
                                                    }) :
                                                        toINR({
                                                            value: formik.values.fund.reduce((pre: any, curr: any) => pre + (curr?.sip?.sipamount ? parseFloat(curr?.sip?.sipamount || '0') : parseFloat(curr?.lumpsum?.lumpAmount || '0')), 0),
                                                            locale,
                                                            currencyCode
                                                        })}
                                                </Typography>
                                            )}
                                            {isLoading ? (
                                                <Skeleton variant="text" animation="wave" width={100} />
                                            ) :
                                                <Typography variant="body_500" color={palette.text.secondary} fontSize={{ sm: '14px', xs: '14px', md: '16px', lg: '16px' }}>
                                                    Total Amount
                                                </Typography>
                                            }
                                        </Box>
                                        {role === USER_ROLES.RM && (!isLoading) && mfTxnStatus && (
                                            <Typography variant="overline_600" sx={(theme: Theme) => ({ mt: 2, color: theme.palette.error[500] })} >
                                                You are not allowed to place any transactions as your transaction status is still not active.
                                            </Typography>
                                        )}

                                        <Box sx={{ display: 'flex', gap: '15px', flexDirection: 'row' }}>
                                            {/* {[USER_ROLES.RM].includes(role) && */}
                                            {![USER_ROLES.INVESTOR].includes(role) &&
                                                <>
                                                    {(isModuleAllowed({ value: "OrderRecommend", compareArr: permissions, objKey: "permissonCode" })) && (
                                                        <CustomeButton
                                                            lookType={'outlined'}
                                                            btnText={'Suggested'}
                                                            isLoading={["recomment"].includes(apiLoading)}
                                                            disabled={
                                                                // (details?.investmentDetails?.length || 0) === 0 ||
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    ![USER_ROLES.INVESTOR].includes(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["POA"]
                                                                ) ||
                                                                ["order", "investor"].includes(apiLoading) ||
                                                                TransactionStatusChkLoading
                                                            }
                                                            onClick={async () => {
                                                                setOrderType('recomment')
                                                                // formik.handleSubmit()
                                                            }}
                                                        />
                                                    )}
                                                    {(isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })) && (
                                                        <CustomeButton lookType={'contained'} btnText={'Place Order'}
                                                            isLoading={["order"].includes(apiLoading) || TransactionStatusChkLoading}
                                                            disabled={
                                                                // (details?.investmentDetails?.length || 0) === 0 ||
                                                                ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                                isLoading ||
                                                                isBankBalanceObjLoading ||
                                                                EUINPopupLoading ||
                                                                (ENABLE_MF_TRANSACTIONS_POA_DOCUMENT_UPLOAD &&
                                                                    ![USER_ROLES.INVESTOR].includes(role) &&
                                                                    MPOWER_ACCOUNT_TYPE_MASTER[selectedPortfolioObj?.portfolioAccountType?.toUpperCase()] ===
                                                                    MPOWER_ACCOUNT_TYPE_MASTER["ADV"]
                                                                ) ||
                                                                ["recomment", "investor"].includes(apiLoading) ||
                                                                TransactionStatusChkLoading || mfTxnStatus || !disclaimerChecked
                                                            }
                                                            // disabled={selectedSchemes.length === 0 || isLoading || TransactionStatusChkLoading}
                                                            onClick={async () => {
                                                                setOrderType('order')
                                                                // formik.handleSubmit()
                                                            }}
                                                        />
                                                    )}
                                                </>
                                            }
                                            {(
                                                [USER_ROLES.INVESTOR].includes(role) &&
                                                isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
                                            ) && (
                                                    <CustomeButton
                                                        lookType={'contained'}
                                                        btnText={'Add to Cart'}
                                                        isLoading={["investor"].includes(apiLoading)}
                                                        // (formRef.current?.values?.fund ?? [])
                                                        disabled={
                                                            // (details?.investmentDetails?.length || 0) === 0 ||
                                                            ((formRef.current?.values?.fund ?? [])?.length || 0) === 0 ||
                                                            isLoading ||
                                                            isBankBalanceObjLoading ||
                                                            ["order", "recomment"].includes(apiLoading) || mfTxnStatus
                                                        }
                                                        // disabled={selectedSchemes.length === 0 || isLoading}
                                                        onClick={async () => {
                                                            setOrderType('investor')
                                                            // formik.handleSubmit()

                                                        }}
                                                    />
                                                )}
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        {/* Document Upload Dialog Start */}
                        <TransactionsDocumentUpload
                            open={isDocumentUploadDialogVisible}
                            onClose={handleDocumentUploadDialogClose}
                        />
                        {/* Document Upload Dialog End */}

                        {/* Multiple Orders from the same scheme/folio combination Dialog start */}
                        <ConfirmRecomment
                            open={isSameSchemesDialogOpen}
                            setClose={handleSameSchemeDialogClose}
                            title="Confirm!"
                            desc="Multiple Orders with the same scheme/folio combination. Please confirm before proceeding."
                            handleConfirm={handleSameSchemeDialogConfirm}
                        />
                        {/* Multiple Orders from the same scheme/folio combination Dialog end */}
                    </>
                )}
            </Formik >

            {open &&
                isInvestMore ?
                <HoldingFundMore {...{ open, setOpen, clientCode: clientCode, holdingsData, setHoldingsData, handleProceed, setSchemeAllDetails }} /> :
                <MoreFundsModal {...{ open, setOpen, clientCode: clientCode, handleAddMoreProceed, handleAddMoreChangeRadion, radioValue, setRadioValue, setWarning, warning, setSchemeAllDetails }} />
            }
            <ConfirmRecomment
                isLoading={!!apiLoading}
                open={confirmRecomment}
                setClose={setConfirmRecomment}
                title={orderType === 'recomment' ? "Confirm Suggestion!" : orderType === 'order' ? "Confirm!" : ''}
                desc={orderType === 'recomment' ? "Are you sure you want to continue with this action ? You can see your old suggestions under recent suggestion tab." : "Are you sure you want to continue with this action ?"}
                handleConfirm={() => orderType === 'recomment' ? handleConfirmRecommend() : orderType === 'order' && handleConformOrder()}
            />
            <RiskProfilePopup open={riskProfilePopup} setClose={handleRiskProfilePopup} handleConfirmOrder={handleConformOrder} isLoading={apiLoading} text={riskPopupText} />

            {
                cartPopup &&
                <AddtoCardPopup open={cartPopup} setClose={setCartPopup} handleSuccess={handleSuccess} />
            }
            <SuccessModal
                open={successModal}
                setClose={setSuccessModal}
                onclick={handleSuccessPopup}
                title="Success!"
                confirmBtnText={"Go to Dashboard"}
                // confirmBtnText={pathname.split('/')[pathname.split('/').length - 1] === 'invest-more' ? "Go to Mutual Fund Holding" : 'Go to Mutual Fund Orders'}
                // desc={orderType === 'recomment' ? "Your Suggestion is sent successfully to the Investor." : "The transaction link will be sent via email by BSE Star for authorisation and completion of the transaction."}
                desc={successMessage ?? ""}
                subDesc={subSuccessMessage ?? ""}
            />
            <FiveSchemeErrorMessage handleCloseFiveSchemesDialog={handleCloseFiveSchemesDialog} isFiveSchemesDialogVisible={isFiveSchemesDialogVisible} />
            <ValidateDialogBox handleValidationDialogClose={handleValidationDialogClose} validationErrorsArray={validationErrorsArray} isValidationDialogVisible={isValidationDialogVisible} />
            <TransactionStatusPopup open={transactionStatusPopup} setClose={handleTransactionStatusPopup} res={transactionStatusPopupRes} />
            <EUINPopup open={EUINPopupVisible} setClose={() => setEUINPopupVisible(false)} handleEuinCheckClose={handleEuinCheckClose} euinRes={EUINPopupRes} />
            <TransactionStatusCheckPopup open={transactionStatusCheckPopup} setClose={handleTransactionStatusCheckPopup} res={transactionStatusCheckPopupRes} />

            <TransactionsDisclaimerText
                handleDialogClose={() => {
                    setIsTxnDialog(false);
                    setDisclaimerChecked(true);
                }}
                isDialog={isTxnDialog}
            />

            {/* Document Upload Error Dialog Start */}
            <Dialog
                aria-labelledby="error-dialog"
                open={isDocumentUploadErrorDialogVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "12px",
                        padding: "15px",
                        overflow: "hidden"
                    }}
                >
                    <FailureIcon width="35" height="35" />
                    <Typography
                        variant="h2"
                        sx={{
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: palette.text.primary
                        }}
                    >
                        Error!
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={{
                            lineHeight: "22px",
                            letterSpacing: "0.02px",
                            color: palette.text.secondary,
                            textAlign: "center",
                            paddingLeft: "10px",
                            paddingRight: "10px"
                        }}
                    >
                        Please upload minimum 1 document
                    </Typography>
                </DialogContent>
                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleDocumentUploadErrorDialogClose}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Document Upload Error Dialog End */}

            {/* Research Schemes Dialog Start */}
            <Dialog
                aria-labelledby="research-schemes-dialog"
                onClose={() => setResearchSchemesPopupVisible(false)}
                open={researchSchemesPopupVisible}
                PaperProps={{
                    sx: {
                        maxWidth: '550px',
                        width: "100%",
                        borderRadius: "12px",
                        padding: "24px",
                        backgroundColor: palette.common.white
                    },
                }}
            >
                <DialogTitle
                    id="research-schemes-dialog-title"
                    sx={{
                        padding: "0px 0px 12px 0px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        ...typography.h2,
                        lineHeight: "23px",
                        letterSpacing: "0.01px",
                        color: palette.text.primary,
                    }}
                >
                    {researchSchemesMessage}
                    <IconButton
                        aria-label="close"
                        onClick={() => setResearchSchemesPopupVisible(false)}
                        sx={{
                            padding: "5px",
                            marginTop: "-5px"
                        }}
                    >
                        <BlackExitIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent
                    sx={{
                        padding: "0px",
                        overflow: "hidden"
                    }}
                >
                    {researchSchemesList && researchSchemesList.length > 0 && (
                        <Box sx={{ mb: '24px' }}>
                            <List
                                sx={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    backgroundColor: palette.grey[50],
                                    borderRadius: '8px',
                                    p: '12px'
                                }}
                            >
                                {researchSchemesList.map((schemeName, index) => (
                                    <ListItem
                                        key={index}
                                        sx={{
                                            py: '8px',
                                            px: '12px',
                                            borderBottom: index < researchSchemesList.length - 1 ? `1px solid ${palette.grey[200]}` : 'none'
                                        }}
                                    >
                                        <Typography variant='body_400' color={palette.text.secondary}>
                                            {schemeName}
                                        </Typography>
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    )}
                </DialogContent>

                <DialogActions
                    sx={{
                        padding: "0px",
                        marginTop: "40px",
                    }}
                >
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={() => setResearchSchemesPopupVisible(false)}
                        sx={{
                            ...typography.body_500,
                            fontWeight: 600,
                            lineHeight: "20px",
                            color: palette.common.white,
                            borderRadius: "4px",
                            padding: "13px 20px",
                            backgroundColor: palette.primary[500]
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Research Schemes Dialog End */}
        </>
    )
}

export default Transaction